import React from 'react';
import PayrollSummaryItem from "./PayrollSummaryItem";
import PropTypes from 'prop-types'

const PeriodPayrollItem = (props) => {
  // El componente tiene tres estados
  // Normal - default
  // Bloqueado - pasando la propiedad isLocked
  // Completado - Pasando la propiedad isSolved

  const { isLocked, isSolved, title, content } = props
  const statusClass = `${isLocked && 'is-locked'} ${isSolved && 'is-solved'}`

  return (
    <PayrollSummaryItem
      className={`payroll-summary-item ${statusClass}`}
      icon={isSolved ? 'check' : isLocked ? 'lock' : 'document'}
      title={title}
      content={content}
    />
  );
};

PeriodPayrollItem.propTypes = {
  isLocked: PropTypes.bool,
  isSolved: PropTypes.bool,
}

PeriodPayrollItem.defaultProps = {
  isLocked: false,
  isSolved: false,
}

export default PeriodPayrollItem;
